<template>
  <div
    style="
  background: #ffffff; padding:20px;
  border-radius: 8px;  box-shadow: 0 2px 6px rgba(0,0,0,0.1);"
  >
    <div style="font-size: 18px;font-weight: 700;color: #000000;">
      備註
      <span v-if="mode === 'edit'" style="color: #6C6B6B; font-size: 16px;">(ex:寵物-睡覺要蓋小被)</span>
    </div>
    <el-input v-model="bookingOrderNote" :disabled="mode === 'view'" placeholder="請輸入備註" @change="handleNoteChange" style="margin: 16px 0px 10px;" />
  </div>
</template>

<script>
export default {
  name: 'OrderNotePartial',
  components: {},
  props: {
    mode: {
      type: String,
      default: 'edit',
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      bookingOrderNote: this.value,
    }
  },
  watch: {
    value(newVal) {
      this.bookingOrderNote = newVal
    },
  },
  computed: {},
  methods: {
    handleNoteChange(val) {
      this.$emit('update-order-note', val)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-input.is-disabled .el-input__inner {
  background-color: #ffffff;
  color: #000000;
}
</style>
